import * as React from 'react';
export const ApplicationLauncherItemContext = React.createContext({ isExternal: false, icon: null });
//# sourceMappingURL=ApplicationLauncherItemContext.js.map